import { format } from "date-fns";

export const dateToTime = (date) => {
    return format(date, "dd MMM yyyy, HH:mm:ss");
};
export const getType = (type) => {
    if (type === "conceptual_match_count") {
        return "conceptual";
    } else if (type === "exact_match_count") {
        return "exact";
    } else {
        return "both";
    }
};
